import round from 'lodash/round';

const EXPONENTIAL_ZOOM_BASE = 2;
export const LOGRAITHMIC_ZOOM_BASE: number = Math.log(2);
export const LINEAR_ZOOM_STEP = 0.1;
export const MAXIMUM_LINEAR_ZOOM = 1;
export const MINIMUM_LINEAR_ZOOM = -1;
const ZOOM_COMPARISON_PRECISION = 5;

// convert exponential diagram zoom to a linear ak-range accessible value
export const getLinearZoom = (exponentialZoom: number): number =>
	Math.log(exponentialZoom) / LOGRAITHMIC_ZOOM_BASE;

// convert linear ak-range value to exponential diagram zoom value
export const getExponentialZoom = (linearZoom: number): number =>
	EXPONENTIAL_ZOOM_BASE ** linearZoom;

// Apply rounding and snapping logic to linear zoom values
export const snapLinearZoom = (
	linearZoom: number,
	minimumLinearZoom: number,
	maximumLinearZoom: number,
): number => {
	const snappedZoom = round(linearZoom, ZOOM_COMPARISON_PRECISION);

	// Snap to max if very close (handles non-aligned step boundaries)
	if (Math.abs(snappedZoom - maximumLinearZoom) < LINEAR_ZOOM_STEP / 2) {
		return maximumLinearZoom;
	}

	// Snap to min if very close
	if (Math.abs(snappedZoom - minimumLinearZoom) < LINEAR_ZOOM_STEP / 2) {
		return minimumLinearZoom;
	}

	return snappedZoom;
};

export const isMinimumZoom = (linearZoom: number, minimumLinearZoom: number): boolean => {
	return (
		round(linearZoom, ZOOM_COMPARISON_PRECISION) <=
		round(minimumLinearZoom, ZOOM_COMPARISON_PRECISION)
	);
};

export const isMaximumZoom = (linearZoom: number, maximumLinearZoom: number): boolean => {
	return (
		round(linearZoom, ZOOM_COMPARISON_PRECISION) >=
		round(maximumLinearZoom, ZOOM_COMPARISON_PRECISION)
	);
};
